import { z } from 'zod';
/**
 * Factory tool manifest (`factory/tools/<id>/tool.json`), per PRD Epic K,
 * TechSpec §19.2 and ADR-0007.
 *
 * The status enum values are i18n keys; the French labels live in the UI.
 * `deploy-tool.mjs` validates every manifest against this schema before it
 * builds anything, so an unknown key is an error rather than silently ignored.
 */
export const TOOL_STATUSES = [
    'spec',
    'valide',
    'en_construction',
    'a_tester',
    'accepte',
    'retire',
];
export const ToolStatusSchema = z.enum(TOOL_STATUSES);
export const ToolManifestSchema = z
    .object({
    /** Kebab-case, unique, immutable: URL path segment and compose project name. */
    id: z.string().regex(/^[a-z0-9][a-z0-9-]{1,40}$/),
    name: z.string().min(1).max(80),
    description: z.string().max(400),
    stack: z.array(z.string()).min(1),
    port: z.number().int().min(1024).max(65535),
    healthPath: z.string().startsWith('/'),
    status: ToolStatusSchema,
    createdAt: z.iso.datetime({ offset: true }),
    validatedAt: z.iso.datetime({ offset: true }).optional(),
    promotedTo: z.enum(['connector', 'widget', 'hosted']).optional(),
})
    .strict();
/**
 * Lifecycle (PRD VS-114): spec → valide → en_construction → a_tester →
 * accepte | retire, plus a_tester → en_construction for iterations.
 */
export const TOOL_STATUS_TRANSITIONS = {
    spec: ['valide'],
    valide: ['en_construction'],
    en_construction: ['a_tester'],
    a_tester: ['accepte', 'retire', 'en_construction'],
    accepte: [],
    retire: [],
};
export function canTransition(from, to) {
    return TOOL_STATUS_TRANSITIONS[from].includes(to);
}
/** Throws a ZodError when the manifest is invalid. */
export function parseToolManifest(input) {
    return ToolManifestSchema.parse(input);
}
export function safeParseToolManifest(input) {
    return ToolManifestSchema.safeParse(input);
}
//# sourceMappingURL=factory.js.map